import {
    ClientMessage,
    LocationClientService,
    StoreModel,
} from '@/types/locationServerApi';
import { Ref, ref } from 'vue';
import utilities from '@/shared/utilities.service';
import { ImageFileModel } from '@/types/B2BcontentServerContract';
import httpService from '@/core/http/http.service';

interface ImageFileModelClientResponse {
    model: ImageFileModel | undefined;
    messages: ClientMessage[] | undefined;
}

export interface StoreModelWithImage extends StoreModel {
    image: ImageFileModel | undefined;
}

const storesCache = new Map<string, StoreModelWithImage>();

export default function useStore(id: string): Ref<StoreModelWithImage> {
    const store = ref({} as StoreModelWithImage);

    const fetchStore = async(): Promise<void> => {
        const cache = storesCache.get(id);
        if (cache) {
            store.value = cache;
        } else {
            const response = await LocationClientService.getStoreById(id).then(utilities.unwrapModel);
            const responseWithImage = response as StoreModelWithImage;
            if (response?.imageUrl) {
                const image = await httpService.get<ImageFileModelClientResponse>(response.imageUrl).then(utilities.unwrapModel);
                responseWithImage.image = image;
            }
            store.value = responseWithImage ?? {} as StoreModelWithImage;
            storesCache.set(id, store.value);
        }
    };

    fetchStore();

    return store;
}
